/* Built In Imports */
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';

/* External Imports */
import { ChevronDownIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, FormControl, Link, Text } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import config from '@config';
import LBContactUsCta from '@lb/components/Message/LBContactUsCta';
import { refineUrlDomain } from '@lb/components/Utility/utils';

/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';

/* Currency */
import Currency from '@constants/Currency';

/* Styles */
/* Services */

/**
 * Render Ritual Locate Components
 *
 * @param sectionContent
 * @param pageData
 */

const RitualLocate = ({ pageData, lang, region }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPriceMsgOpen, setIsPriceMsgOpen] = useState([]);
  const [variants, setVariants] = useState([]);
  const [curLoc, setCurLoc] = useState({ name: 'Select' });
  const [finalLoc, setFinalLoc] = useState([]);
  const ritualStaticContent = pageData?.ritualStaticContent;
  const router = useRouter();
  const searchParams = useSearchParams();
  const currencys = Currency;

  const selectLoc = (obj, type) => {
    setCurLoc(obj);
    setVariants(obj.variants);
    if (type === 'manual') {
      setIsPriceMsgOpen(prev => [...prev, ...[isPriceMsgOpen.length]]);
    }
  };

  useEffect(
    () => () => {
      setCurLoc({ name: 'Select' });
      setVariants([]);
      setIsOpen(false);
      setIsPriceMsgOpen([]);
    },
    [router.asPath]
  );

  useEffect(() => {
    if (router?.query?.city) {
      let filteredLoc = pageData?.locations.filter(loc => {
        return (
          loc.title?.toLowerCase() ===
            router?.query?.city?.trim().toLowerCase() ||
          loc.name?.toLowerCase() === router?.query?.city?.trim().toLowerCase()
        );
      })[0];
      if (filteredLoc) {
        selectLoc(filteredLoc);
      }
    }
  }, [router?.query?.city]);

  useEffect(() => {
    let locList = pageData?.locations?.filter(loc => {
      return loc.isAvailable === true;
    });
    setFinalLoc(locList);
    if (locList?.length === 1) {
      selectLoc(pageData?.locations[0]);
    }
  }, [region, lang]);

  const FlexText = ({ leftText, rightText }) => {
    return (
      <Flex
        justifyContent="space-between"
        alignItems="center"
        width="100%"
        h="auto"
      >
        <Text
          fontSize={'body2'}
          fontFamily={'FedraSerifAStdBook'}
          fontWeight={'350'}
          lineHeight="190%"
          fontStyle="normal"
          color="bodyText.color3"
        >
          {leftText}
        </Text>
        <Text
          fontSize={'body1'}
          fontFamily={'FedraSerifStd-A-medium'}
          fontWeight={'500'}
          lineHeight="190%"
          fontStyle="normal"
          color="bodyText.color3"
        >
          {rightText}
        </Text>
      </Flex>
    );
  };

  if (!pageData?.arpanam?.ritual?.arpanamId) {
    return (
      <Flex
        alignItems="center"
        justifyContent="center"
        w="100%"
        mt="40px"
        mb={{ base: '40px', md: '40px' }}
        flexDirection="column"
      >
        <Box
          padding={{ base: '20px', md: '30px' }}
          maxW="696px"
          width="100%"
          // maxH={{base:'212px', md:'189px'}}
          height="auto"
          backgroundImage={`${config.imgPath}/d/46272/1683174221-image-61-1.jpg`}
          backgroundRepeat="no-repeat"
          backgroundPosition="center"
          backgroundSize="cover"
        >
          <FlexText
            leftText={
              <Box>
                <Text
                  fontSize={{ base: '26px', md: '32px' }}
                  lineHeight={{ base: '27.82px', md: '34.24px' }}
                  fontWeight="350"
                  fontFamily={'FedraSerifAStdBook'}
                  color="secondary.main"
                >
                  {ritualStaticContent?.json?.unavailableLargeText}
                </Text>
                <Text
                  fontSize="15px"
                  lineHeight="24px"
                  fontWeight="350"
                  fontFamily={'FedraSerifAStdBook'}
                  color="title.light"
                >
                  {ritualStaticContent?.json?.unavailableSmallText}
                </Text>
              </Box>
            }
            rightText={<Box></Box>}
          />
        </Box>
      </Flex>
    );
  }

  return !pageData?.overrideRegistrationLogic ? (
    <>
      <Flex
        alignItems="center"
        justifyContent="center"
        w="100%"
        mt="40px"
        mb={{ base: '40px', md: '40px' }}
        flexDirection="column"
      >
        <Box
          padding={{ base: '20px', md: '30px' }}
          maxW="696px"
          width="100%"
          // maxH={{base:'212px', md:'189px'}}
          height="auto"
          backgroundImage={`${config.imgPath}/d/46272/1683174221-image-61-1.jpg`}
          backgroundRepeat="no-repeat"
          backgroundPosition="center"
          backgroundSize="cover"
        >
          <FlexText
            leftText={
              <Box>
                {!pageData?.arpanam?.ritual?.isAvailable &&
                  pageData?.arpanam?.ritual?.hasOwnProperty(
                    'showRegionUnavailableMessage'
                  ) &&
                  finalLoc?.length > 0 < 1 && (
                    <>
                      <Text
                        fontSize={{ base: '26px', md: '32px' }}
                        lineHeight={{ base: '27.82px', md: '34.24px' }}
                        fontWeight="350"
                        fontFamily={'FedraSerifAStdBook'}
                        color="secondary.main"
                      >
                        {ritualStaticContent?.json?.unavailableLargeTextRegion}
                      </Text>
                      <Text
                        fontSize="15px"
                        lineHeight="24px"
                        fontWeight="350"
                        fontFamily={'FedraSerifAStdBook'}
                        color="title.light"
                      >
                        {ritualStaticContent?.json?.unavailableSmallTextRegion}
                      </Text>
                    </>
                  )}

                {!pageData?.arpanam?.ritual?.isAvailable &&
                  pageData?.arpanam?.ritual?.hasOwnProperty(
                    'showUnavailableMessage'
                  ) &&
                  finalLoc?.length < 1 && (
                    <>
                      <Text
                        fontSize={{ base: '26px', md: '32px' }}
                        lineHeight={{ base: '27.82px', md: '34.24px' }}
                        fontWeight="350"
                        fontFamily={'FedraSerifAStdBook'}
                        color="secondary.main"
                      >
                        {ritualStaticContent?.json?.unavailableLargeText}
                      </Text>
                      <Text
                        fontSize="15px"
                        lineHeight="24px"
                        fontWeight="350"
                        fontFamily={'FedraSerifAStdBook'}
                        color="title.light"
                      >
                        {ritualStaticContent?.json?.unavailableSmallText}
                      </Text>
                    </>
                  )}

                {finalLoc?.length > 0 && (
                  <>
                    <Text
                      fontSize={{ base: '26px', md: '32px' }}
                      lineHeight={{ base: '107%', md: '40px' }}
                      fontWeight="500"
                      fontFamily={'FedraSerifAStdBook'}
                      color="title.light"
                    >
                      {ritualStaticContent?.json?.location}
                    </Text>

                    <Text
                      fontSize="15px"
                      lineHeight="24px"
                      fontWeight="350"
                      fontFamily={'FedraSerifAStdBook'}
                      color="title.light"
                      mt="3px"
                    >
                      {ritualStaticContent?.json?.locationDescription}
                    </Text>
                  </>
                )}
              </Box>
            }
            rightText={
              <Box display={{ base: 'none', md: 'block' }}>
                {finalLoc?.length > 0 && (
                  <>
                    <Text
                      fontSize="32px"
                      lineHeight="107%"
                      fontWeight="500"
                      paddingRight={{ md: '70px' }}
                      // w="101px"
                      fontFamily="FedraSerifAStdBook"
                      color="#FFCB66"
                      p="10px 0 0 0"
                    >
                      {curLoc?.price}
                    </Text>
                  </>
                )}
              </Box>
            }
          />

          {(pageData?.globalRegLink || finalLoc?.length > 0) && (
            <FormControl p="30px 0px 0 0">
              <Flex
                width="100%"
                h="auto"
                justifyContent="space-between"
                flexWrap="wrap"
              >
                <Box position="relative" pb={{ base: '15px', sm: '0' }}>
                  <Button
                    bg="#ffffff"
                    border="1px solid #B7987E"
                    color="#B7987E"
                    minW={{ base: '192px', md: '227px' }}
                    maxH={{ base: '36px', md: '42px' }}
                    rounded="full"
                    _hover={{ border: '1px solid #B7987E' }}
                    _focus={{ border: '1px solid #B7987E' }}
                    _active={{ border: '1px solid #B7987E' }}
                    rightIcon={<ChevronDownIcon />}
                    onClick={() => setIsOpen(true)}
                    // onMouseEnter={() => setIsOpen(true)}
                    onBlur={() => setTimeout(() => setIsOpen(false), 1000)}
                    className="selectButton"
                  >
                    <Flex alignItems="flex-start" w="100%">
                      <Text
                        textAlign="left"
                        color={curLoc.name !== 'Select' ? '#A33A2C' : '#B7987E'}
                      >
                        {curLoc?.name || curLoc?.title}
                      </Text>
                    </Flex>
                  </Button>
                  {isOpen && finalLoc?.length > 0 && (
                    <Flex
                      _before={{ content: "''", height: '17px' }}
                      _after={{ content: "''", height: '17px' }}
                      display={isOpen ? 'block' : 'none'}
                      _hover={{ display: 'block' }}
                      className="options"
                      onMouseLeave={() => setIsOpen(false)}
                      onClick={() => setIsOpen(false)}
                      position="absolute"
                      top={{ base: '45px', md: '47px' }}
                      border="10px solid transparent"
                      zIndex="10"
                      left="0"
                      borderRadius="14px"
                      flexDir="column"
                      bg="#ffffff"
                      mt="5px"
                      w="281px"
                      p="0"
                    >
                      {curLoc?.name !== 'Select' && curLoc?.name !== 'Select' && (
                        <Box
                          padding="8px 24px"
                          cursor="pointer"
                          onClick={() => {
                            selectLoc({ title: 'Select' }, 'manual');
                          }}
                        >
                          <Text color="#B7987E" _hover={{ color: '#A33A2C' }}>
                            {ritualStaticContent?.json?.select}
                          </Text>
                        </Box>
                      )}

                      {pageData?.locations?.map((loc, index) => {
                        return (
                          loc.isAvailable && (
                            <Box
                              padding="8px 24px"
                              key={nanoid()}
                              onClick={() => {
                                selectLoc(loc, 'manual');
                              }}
                              cursor="pointer"
                            >
                              <Text
                                color="#B7987E"
                                fontFamily="FedraSansStd-book"
                                _hover={{ color: '#A33A2C', fontWeight: '600' }}
                              >
                                {loc.title || loc.name}
                              </Text>
                            </Box>
                          )
                        );
                      })}
                    </Flex>
                  )}
                </Box>
                <Box display={{ base: 'block', md: 'none' }}>
                  {finalLoc?.length > 0 && (
                    <>
                      <Text
                        fontSize={{ base: 'h6', md: '32px' }}
                        lineHeight="107%"
                        fontWeight="500"
                        // w="101px"
                        fontFamily="FedraSerifAStdBook"
                        color="#FFCB66"
                      >
                        {curLoc?.price}
                      </Text>
                    </>
                  )}
                </Box>
                <Box
                  width={{ base: '100%', md: 'auto' }}
                  h="auto"
                  mt={{ base: '20px', md: '0' }}
                  display="flex"
                  py={{ base: '17px', md: '0' }}
                  bg={{ base: 'common.white', md: 'transparent' }}
                  position={{ base: 'fixed', md: 'relative' }}
                  alignSelf="center"
                  bottom="0"
                  right="0"
                  zIndex="10"
                >
                  {(curLoc?.regLink || pageData?.globalRegLink) && (
                    <Link
                      href={refineUrlDomain(
                        curLoc?.regLink || pageData?.globalRegLink,
                        region,
                        lang,
                        searchParams.get('selection_source')
                      )}
                      mx="auto"
                      width={{ base: '100%', md: 'auto' }}
                      bottom="0"
                      right="0"
                      variant="primary"
                      textDecoration="none"
                      _hover={{ textDecoration: 'none' }}
                      _focus={{ textDecoration: 'none' }}
                      _active={{ textDecoration: 'none' }}
                      target={'_blank'}
                      p="0 15px"
                    >
                      <Button
                        variant="primary"
                        _hover={{ textDecoration: 'none' }}
                        _focus={{ textDecoration: 'none' }}
                        _active={{ textDecoration: 'none' }}
                        size="lg"
                        fontWeight="300"
                        w={{ base: '100%', md: '211px' }}
                        height="52px"
                        fontSize={{ base: '20px', md: '22px' }}
                        onClick={e => {
                          const Mixpanel = mixPanel(router.asPath);
                           // Get currency
                            let curCurrency = '';
                            currencys.filter(item => {
                              if(region.toLowerCase() === item?.value?.toLowerCase()){
                                curCurrency = item?.name;
                              }
                            });
                            // Get arpanam Id
                            let aprID= '';
                            if(curLoc?.regLink){
                              let str = curLoc?.regLink;
                              aprID = str.substring(str.lastIndexOf('/') + 1);
                            }
                            // Get lowest amount from multiple amount.
                            let BookValue = curLoc?.price?parseInt(curLoc?.price.match(/(\d+)/)):'';
                            if(!curLoc?.price){
                              const values = [];
                              variants?.map((variant, index) => {
                                let matches = parseInt(variant.price.match(/(\d+)/));
                                values.push(matches);
                              });
                              BookValue = Math.min(...values);
                             }
                             const asignValue = (key, value) => {
                              // Initialize an empty object
                              const obj = {};
                              // Check if the value is not empty (null, undefined, empty string, etc.)
                              if (value) {
                                obj[key] = value;
                              }
                              return obj;
                            }; 
                            //Validation if value is empty, will not be added in obj.
                            if(!curLoc?.name || curLoc?.name.toLowerCase() =='select'){
                              curCurrency = '';
                              curLoc.name = '';
                              BookValue ='';
                            }
                            const valueList= {
                              ...asignValue("ritual_name",pageData.title),
                              ...asignValue("ritual_id", aprID),
                              ...asignValue("ritual_amount", BookValue),
                              ...asignValue("ritual_location", curLoc?.name),
                              ...asignValue("selection_source", searchParams.get('selection_source')),
                              ...asignValue("currency", curCurrency),
                            };
                            // Mixpanel trigger
                            Mixpanel.track('lb_ritual_location_selected', {
                              ritual: valueList
                            });
                        }}
                      >
                        Book
                      </Button>
                    </Link>
                  )}
                </Box>
              </Flex>
              {variants?.length > 0 && (
                <Text
                  as=""
                  fontSize={'body2'}
                  fontFamily={'FedraSerifAStdBook'}
                  fontWeight={'350'}
                  color="highlightText.color2"
                  lineHeight={'144%'}
                  textAlign={'left'}
                  my="20px"
                >
                  {ritualStaticContent?.json?.groupRitualList}
                </Text>
              )}
              {variants?.map((variant, index) => {
                return (
                  <FlexText
                    key={nanoid()}
                    leftText={variant?.name}
                    rightText={variant.price}
                  />
                );
              })}
            </FormControl>
          )}
        </Box>
        {isPriceMsgOpen.length > 1 && (
          <LBContactUsCta
            maxW="590px"
            m="0 auto"
            sectionContent={{
              title: ritualStaticContent?.json?.ritualPriceVariesTitle,
              description: {
                value: {
                  schema: 'dast',
                  document: {
                    type: 'root',
                    children: [
                      {
                        type: 'paragraph',
                        children: [
                          {
                            type: 'span',
                            value:
                              ritualStaticContent?.json
                                ?.ritualPriceVariesDetail,
                          },
                        ],
                      },
                    ],
                  },
                },
              },
            }}
          />
        )}
      </Flex>
    </>
  ) : (
    <Box m="60px"></Box>
  );
};

export default RitualLocate;
